import { useLocation } from '@reach/router';
import { Link } from 'gatsby';
import * as React from 'react';
import { Helmet } from 'react-helmet';
// import clsx from 'clsx';
import { buildLink, getLocale } from '../utils/locale';
import { NotFoundLayout } from '../layouts/notfoundlayout';

const NotFound = () => {
	const { pathname } = useLocation();
	const locale = getLocale(pathname);
	const [gtmID, setGtmID] = React.useState();
	const [location, setLocation] = React.useState(null);

	React.useEffect(() => {
		if (locale) {
			setLocation(locale);
		}
	}, [locale]);

	React.useEffect(() => {
		if (locale === 'ie') {
			setGtmID(process.env.GATSBY_GTM_IE_TRACKING_ID);
		} else if (locale === 'ca') {
			setGtmID(process.env.GATSBY_GTM_CA_TRACKING_ID);
		} else {
			setGtmID(process.env.GATSBY_GTM_TRACKING_ID);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getHomepageLink = (loc) => {
		switch (loc) {
			case 'au':
				return 'https://peninsulagrouplimited.com.au/';
			case 'ca':
				return buildLink(loc, '/');
			case 'ie':
				return buildLink(loc, '/');
			default:
				return buildLink(loc, '/');
		}
	};

	const getContactLink = (loc) => {
		switch (loc) {
			case 'au':
				return 'https://peninsulagrouplimited.com.au/contact-us';
			case 'ie':
				return buildLink(loc, '/contact');
			case 'ca':
				return buildLink(loc, '/contact-us');
			default:
				return buildLink(loc, '/contact-us');
		}
	};

	return (
		<NotFoundLayout locale={locale}>
			<Helmet>
				<title>Page not found</title>
				<script>
					{`window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('consent', 'default', {
                            'ad_storage': 'denied',
                            'ad_user_data': 'denied',
                            'ad_personalization': 'denied',
                            'analytics_storage': 'denied'
                        })`}
				</script>
				<script id="gtag-config">
					{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${gtmID}');
                `}
				</script>
			</Helmet>

			<main className="bg-black lg:h-[91.7vh] h-screen flex flex-col items-center justify-center text-white px-4">
				<title>Not found</title>
				<div className="flex flex-col items-center text-center">
					<div className="flex gap-4 items-center">
						<div className="text-5xl sm:text-6xl font-bold mb-4">
							404
						</div>
					</div>
					<h2 className="text-4xl sm:text-5xl md:text-7xl notosans-light font-semibold mb-6">
						Page not found
					</h2>
					<p className="text-base sm:text-lg md:text-xl mb-8 text-gray-300">
						Sorry, we couldn’t find the page you’re looking for.
					</p>
					<div className="flex flex-col sm:flex-row gap-4 sm:gap-5">
						<Link
							to={getHomepageLink(location)}
							className="px-6 py-3 bg-blue-400 text-white text-lg font-medium rounded-lg shadow-lg hover:bg-brand-blue-500 transition duration-300"
						>
							Return to Homepage
						</Link>
						<Link
							to={getContactLink(location)}
							className="px-4 sm:px-6 py-2 sm:py-3 text-white md:text-blue-400 text-sm sm:text-lg font-medium hover:text-white transition duration-300"
						>
							Contact support →{' '}
						</Link>
					</div>
				</div>
			</main>
		</NotFoundLayout>
	);
};

export default NotFound;
